var app = angular.module("leonardo");

var TaskUnCompleteDialog = function($scope, $rootScope, FormErrorsService, AnalyticsService) {
  $scope.task = $scope.ngDialogData.task;

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.task.reopen({}).then(function(response) {
      AnalyticsService.track("Task Reopened", { 
        ...AnalyticsService.getTaskGroupProperties(response),
        previous_status: 'completed'
      });
      $scope.closeThisDialog();
      $rootScope.$broadcast('task-un-resolve-dialog:success');
    });
  };
};

app.controller('TaskUnCompleteDialog', ['$scope', '$rootScope', 'FormErrorsService', 'AnalyticsService', TaskUnCompleteDialog]);
